<template>
	<div v-if="data && offerings">
		{{ offerings[data.offeringid].name }} {{ offerings[data.offeringid].description }}
	</div>
</template>
